"use client";

import { useEffect, useState } from "react";
import { deviceDetector } from "@ospweb/sdk-ui";
import { getValue } from "utils";
import { Track } from "@/src/lib/tracking";
import { useAppFeatures } from "@/src/lib/bridge/useBridge";
import { REMOTE_CONFIG_KEY_IOS_APP_EXTERNAL_MANAGE_ENABLED } from "@features/firebase/remoteConfigKeys";
import { canOpenExternal } from "@utils/member/openExternal";
import type { SubscriptionActionEnv } from "./subscriptionActions";

const DISABLED_VALUE = "false";

/**
 * 订阅管理的外跳能力（EDG-552）：非 App 恒可外跳；App 内需原生声明 `openUrlExternal`，
 * iOS 另受 Remote Config 降级开关约束（读不到按开启，不误伤）。
 */
export function useSubscriptionActionEnv(): SubscriptionActionEnv {
  const features = useAppFeatures();
  const isApp = deviceDetector.isApp();
  const isIOSApp = deviceDetector.isIOSApp();
  const [isIOSExternalAllowed, setIOSExternalAllowed] = useState(true);

  useEffect(() => {
    if (!isIOSApp) {
      return;
    }
    let isActive = true;
    const load = async () => {
      try {
        const value = (
          await getValue(REMOTE_CONFIG_KEY_IOS_APP_EXTERNAL_MANAGE_ENABLED)
        ).asString();
        if (isActive) {
          setIOSExternalAllowed(value.trim().toLowerCase() !== DISABLED_VALUE);
        }
      } catch (error) {
        Track.log("warn", "Member", "[trace][sub] external manage flag", {
          cause: String(error),
        });
      }
    };
    void load();
    return () => {
      isActive = false;
    };
  }, [isIOSApp]);

  return {
    canOpenExternal:
      canOpenExternal(isApp, features) && (!isIOSApp || isIOSExternalAllowed),
  };
}
